import styled from "styled-components";
import { FlexColumn, FlexRow } from "../../common.styles";
import { FileUploadView } from "../../FileUploadView";
import { HXTextField } from "../../base.styles";
import { fontSizes } from "healthex-common/sizes";
import { Text } from "../../HXDesktopPage.styles";
import { fontWeights } from "healthex-common/weights";
import Divider from "@mui/material/Divider";
import { colors } from "healthex-common/colors";
import Add from "@mui/icons-material/Add";
import { StudyTranslationLanguage } from "healthex-common/study-translation-language.dtos";
export const SectionImageUploaderParent = styled(FlexColumn) `
    gap: 16px;
    flex: 1;
`;
export const ImageUploadContainer = styled(FlexColumn) `
    gap: 8px;
`;
export const PlaceholderText = styled(Text) `
    font-weight: ${fontWeights.BOLD};
    color: ${(props) => (props.disabled ? colors.black_30 : props.requiredError ? colors.tulip_main : colors.black_main)};
`;
export const SectionImageUploadView = styled(FileUploadView) `
    min-height: 160px;
    background-color: ${(props) => {
    if (props.hasImage)
        return colors.white_main;
    return props.requiredError ? colors.white_main : colors.navy_8;
}};
    border-radius: 4px;
    border: 2px ${(props) => (props.requiredError || props.language !== StudyTranslationLanguage.en ? "solid" : "dashed")};
    color: ${(props) => (props.disabled ? colors.black_30 : props.requiredError ? colors.tulip_main : colors.black_12)};

    &:hover:not([disabled]) {
        border-radius: 4px;
        border: 2px solid ${colors.black_12};
        background: linear-gradient(0deg, #07142014 0%, #07142014 100%);
        transition: all 0.2s ease;
    }
`;
export const CaptionTextField = styled(HXTextField) `
    width: 100%;
`;
export const ButtonsContainer = styled(FlexRow) `
    gap: 8px;
    align-items: center;
`;
export const ImagesText = styled(Text) `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_main)};
`;
export const VerticalDivider = styled(Divider).attrs({ orientation: "vertical" }) `
    align-self: stretch;
    height: 24px;
    align-self: center;
`;
export const RemoveError = styled(Text) `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.SMALL};
    margin-left: 8px;
`;
export const MenuItemFooterText = styled(Text) `
    font-size: ${fontSizes.SMALL};
    margin-right: 16px;
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_main)};
`;
export const AddIcon = styled(Add) `
    width: 24px;
    height: 24px;
    &&& {
        color: ${(props) => (props.disabled ? colors.black_30 : colors.black_main)};
    }
`;
